// client/extensions/Strike.ts
import TiptapStrike from "@tiptap/extension-strike";
var StrikeTranslations = { strike: { tooltip: ["Durchgestrichen", "Strike"] } };
var Strike = {
  buttons: ({ editor, host }) => [
    {
      name: "toggleStrike",
      icon: "format_strikethrough",
      action: () => editor.chain().focus().toggleStrike().run(),
      tooltip: host.translator.translate("tiptap", "strike", "tooltip")
    }
  ],
  extensions: [TiptapStrike]
};
export {
  Strike,
  StrikeTranslations
};
